import { render, staticRenderFns } from "./InstructionsViewer.vue?vue&type=template&id=7dbc8523&scoped=true"
import script from "./InstructionsViewer.vue?vue&type=script&lang=js"
export * from "./InstructionsViewer.vue?vue&type=script&lang=js"
import style0 from "./InstructionsViewer.vue?vue&type=style&index=0&id=7dbc8523&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbc8523",
  null
  
)

export default component.exports